import type { ObjectId } from "@bbj-types/utils";
import { useCallback } from "react";
import { workshopsAxios } from "./axios";

export const useDeleteWorkshopDocument = () => {
  const [state, execute, cancel] = workshopsAxios<void, void, unknown>(
    {
      method: "DELETE",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (documentId: ObjectId) => {
      return execute({
        url: `/documents/${documentId}`,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
